module.exports = __webpack_public_path__ + "img/Boss-6.2dfc4d89.gif";